export const Workpackage = 'WORKPACKAGE';
export const AssignFM = 'WP_ASSIGN_FM';
export const AssignGF = 'WP_ASSIGN_GF';
export const AssignSUP = 'WP_ASSIGN_SUP';
export const AssignFE = 'WP_ASSIGN_FE';
export const AssignNightFM = 'WP_ASSIGN_NIGHT_FM';
export const CommodityActivity = 'COMMODITY_ACTIVITY';
export const ClaimMilestone = 'CLAIM_MILESTONE';
export const ApproveMilestone = 'APPROVE_MILESTONE';
export const ResolveBlock = 'RESOLVE_BLOCK';
export const ResolveAnyBlock = 'RESOLVE_ANY_BLOCK';
export const CanChangeSuperintendent = 'CAN_CHANGE_SUPERINTENDENT';
export const CanChangeGF = 'CAN_CHANGE_GF';
export const CanChangeFM = 'CAN_CHANGE_FM';
export const CanPlanMilestones = 'CAN_PLAN_MILESTONES';
export const ViewPlan = 'VIEW_PLAN';
